import { PlanCode } from '@workingclock/types';
import { z } from 'zod';

export const createCheckoutSessionSchema = z.object({
  planCode: z.nativeEnum(PlanCode).refine((code) => code !== PlanCode.Free, {
    message: 'The Free plan does not require checkout',
  }),
  billingPeriod: z.enum(['monthly', 'annual']),
});
export type CreateCheckoutSessionInput = z.infer<typeof createCheckoutSessionSchema>;
